import { createTheme } from '@one-thd/sui-atomic-components';

const DecorDaysRed = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

DecorDaysRed.palette['--sui-palette-background-primary'] = '252 80 82';
DecorDaysRed.palette['--sui-palette-button-background-primary'] = '255 255 255';
DecorDaysRed.palette['--sui-palette-text-primary'] = '255 255 255';
DecorDaysRed.palette['--sui-palette-text-subtle'] = '255 255 255';

export { DecorDaysRed };
